import { render } from "./ResetPasswordErrorView.vue?vue&type=template&id=4fe47fa6"
import script from "./ResetPasswordErrorView.vue?vue&type=script&lang=js"
export * from "./ResetPasswordErrorView.vue?vue&type=script&lang=js"

import "./ResetPasswordErrorView.vue?vue&type=style&index=0&id=4fe47fa6&lang=scss"

import exportComponent from "/codebuild/output/src886087124/src/dt-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__